export default "__VITE_ASSET__CW6UV63c__"